<template>
  <div class="base-setup" @click="showIconSelect = false">
    <el-form label-position="top" :model="setup" :rules="rules" ref="baseSetting" label-width="110px">
      <el-row>
        <el-col :span="8">
          <el-form-item label-width="100px" label="名称" prop="name">
            <el-input v-model="setup.formName" style="width: 210px" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label-width="100px" label="图标" prop="name">
            <button class="set-button">
              <el-popover placement="bottom-start" width="500" trigger="click" >
                <div class="icon-select" style="height: 500px;overflow:auto">
                  <i :class="i" v-for="(i, id) in icons" :key="id" @click="setup.logo.icon = i"></i>
                </div>
                <div :class="setup.logo.icon" :style="'background:' + setup.logo.background" class="icon-logo" slot="reference"></div>
              </el-popover>
              <el-color-picker style="margin-left: 10px" v-model="setup.logo.background" show-alpha size="small" :predefine="colors"></el-color-picker>
            </button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label-width="100px" label="所在分组">
            <div style="display: flex">
              <el-select v-model="setup.groupId" placeholder="请选择分组" style="width: 145px;margin-right: 10px">
                <el-option v-for="op in fromGroup" :key="op.id" :label="op.name" :value="op.id"></el-option>
              </el-select>
              <el-popover placement="top" title="新建表单分组" width="300" trigger="click">
                <el-input size="medium" v-model="newGroup" placeholder="请输入新的分组名">
                  <el-button slot="append" size="medium" type="primary" @click="addGroup">提交</el-button>
                </el-input>
                <el-button icon="el-icon-plus" slot="reference" size="medium" type="danger"></el-button>
              </el-popover>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label-width="100px" label="可申请成员" prop="name">
            <button class="set-button" @click="choiceApplyDialog()" style="padding-left: 10px">
              <span v-if="setup.settings.commiter.length<1">请选择</span>
              <el-tag v-if="setup.settings.commiter.length>0" class="tag-name" size="small" type="danger">{{setup.settings.commiter[0].name}}</el-tag>
              <el-tag v-if="setup.settings.commiter.length>1" class="tag-name" size="small" type="danger">{{setup.settings.commiter[1].name}}</el-tag>
              <el-tag v-if="setup.settings.commiter.length>2" size="small" type="danger">+{{setup.settings.commiter.length-2}}</el-tag>
              <div v-else style="position: absolute;transform:translateX(-50%);right: 2px"><span class="el-icon-arrow-down"></span></div>
            </button>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label-width="100px" label="可管理成员" prop="name">
            <button class="set-button"  @click="choiceEditDialog()" style="padding-left: 10px">
              <span v-if="setup.settings.admin.length<1">请选择</span>
              <el-tag v-if="setup.settings.admin.length>0" class="tag-name" size="small" type="danger">{{setup.settings.admin[0].name}}</el-tag>
              <el-tag v-if="setup.settings.admin.length>1" class="tag-name" size="small" type="danger">{{setup.settings.admin[1].name}}</el-tag>
              <el-tag v-if="setup.settings.admin.length>2" size="small" type="danger">+{{setup.settings.admin.length-2}}</el-tag>
              <div v-else style="position: absolute;transform:translateX(-50%);right: 2px"><span class="el-icon-arrow-down"></span></div>
            </button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="23">
          <el-form-item label="表单说明">
            <el-input placeholder="请输入表单说明" v-model="setup.remark" type="textarea" show-word-limit
                      :autosize="{ minRows: 4, maxRows: 5}" maxlength="500" style="width: 97%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
<!--    选择可查看表单人员或部门-->
    <choice-member @ok="applyList"  :titleList="['user','dept','role']" dialogTitle="请选择可查看表单人员或部门" :multiple="true" default-title-name="user" ref="choiceApply"/>
<!--    选择可管理表单人员或部门-->
    <choice-member @ok="editList"  :titleList="['user','dept','role']" dialogTitle="请选择可管理表单人员或部门" :multiple="true" default-title-name="user" ref="choiceEdit"/>
  </div>
</template>

<script>
import {getFormGroups, updateGroup} from '@/api/design'
import ChoiceMember from "@/components/common/ChoiceMember";
export default {
  name: "FormBaseSetting",
  components: {ChoiceMember},
  data() {
    return {
      showIconSelect: false,
      select: [],
      newGroup: '',
      fromGroup: [],
      notifyTypes:[
        {type:'APP',name:'应用内通知'},
        {type:'EMAIL',name:'邮件通知'},
        {type:'SMS',name:'短信通知'},
        {type:'WX',name:'微信通知'},
        {type:'DING',name:'钉钉通知'},
      ],
      colors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577'
      ],
      icons: [
          'cuIcon-appreciate',
          'cuIcon-check',
          'cuIcon-close',
          'cuIcon-edit',
          'cuIcon-emoji',
          'cuIcon-favorfill',
          'cuIcon-favor',
          'cuIcon-loading',
          'cuIcon-locationfill',
          'cuIcon-location',
          'cuIcon-phone',
          'cuIcon-roundcheckfill',
          'cuIcon-roundcheck',
          'cuIcon-roundclosefill',
          'cuIcon-roundclose',
          'cuIcon-roundrightfill',
          'cuIcon-roundright',
          'cuIcon-search',
          'cuIcon-taxi',
          'cuIcon-timefill',
          'cuIcon-time',
          'cuIcon-unfold',
          'cuIcon-warnfill',
          'cuIcon-warn',
          'cuIcon-camerafill',
          'cuIcon-camera',
          'cuIcon-commentfill',
          'cuIcon-comment',
          'cuIcon-likefill',
          'cuIcon-like',
          'cuIcon-notificationfill',
          'cuIcon-notification',
          'cuIcon-order',
          'cuIcon-samefill',
          'cuIcon-same',
          'cuIcon-deliver',
          'cuIcon-evaluate',
          'cuIcon-pay',
          'cuIcon-send',
          'cuIcon-shop',
          'cuIcon-ticket',
          'cuIcon-back',
          'cuIcon-cascades',
          'cuIcon-discover',
          'cuIcon-list',
          'cuIcon-more',
          'cuIcon-scan',
          'cuIcon-settings',
          'cuIcon-questionfill',
          'cuIcon-question',
          'cuIcon-shopfill',
          'cuIcon-form',
          'cuIcon-pic',
          'cuIcon-filter',
          'cuIcon-footprint',
          'cuIcon-top',
          'cuIcon-pulldown',
          'cuIcon-pullup',
          'cuIcon-right',
          'cuIcon-refresh',
          'cuIcon-moreandroid',
          'cuIcon-deletefill',
          'cuIcon-refund',
          'cuIcon-cart',
          'cuIcon-qrcode',
          'cuIcon-remind',
          'cuIcon-delete',
          'cuIcon-profile',
          'cuIcon-home',
          'cuIcon-cartfill',
          'cuIcon-discoverfill',
          'cuIcon-homefill',
          'cuIcon-message',
          'cuIcon-addressbook',
          'cuIcon-link',
          'cuIcon-lock',
          'cuIcon-unlock',
          'cuIcon-vip',
          'cuIcon-weibo',
          'cuIcon-activity',
          'cuIcon-friendaddfill',
          'cuIcon-friendadd',
          'cuIcon-friendfamous',
          'cuIcon-friend',
          'cuIcon-goods',
          'cuIcon-selection',
          'cuIcon-explore',
          'cuIcon-present',
          'cuIcon-squarecheckfill',
          'cuIcon-square',
          'cuIcon-squarecheck',
          'cuIcon-round',
          'cuIcon-roundaddfill',
          'cuIcon-roundadd',
          'cuIcon-add',
          'cuIcon-notificationforbidfill',
          'cuIcon-explorefill',
          'cuIcon-fold',
          'cuIcon-game',
          'cuIcon-redpacket',
          'cuIcon-selectionfill',
          'cuIcon-similar',
          'cuIcon-appreciatefill',
          'cuIcon-infofill',
          'cuIcon-info',
          'cuIcon-forwardfill',
          'cuIcon-forward',
          'cuIcon-rechargefill',
          'cuIcon-recharge',
          'cuIcon-vipcard',
          'cuIcon-voice',
          'cuIcon-voicefill',
          'cuIcon-friendfavor',
          'cuIcon-wifi',
          'cuIcon-share',
          'cuIcon-wefill',
          'cuIcon-we',
          'cuIcon-lightauto',
          'cuIcon-lightforbid',
          'cuIcon-lightfill',
          'cuIcon-camerarotate',
          'cuIcon-light',
          'cuIcon-barcode',
          'cuIcon-flashlightclose',
          'cuIcon-flashlightopen',
          'cuIcon-searchlist',
          'cuIcon-service',
          'cuIcon-sort',
          'cuIcon-down',
          'cuIcon-mobile',
          'cuIcon-mobilefill',
          'cuIcon-copy',
          'cuIcon-countdownfill',
          'cuIcon-countdown',
          'cuIcon-noticefill',
          'cuIcon-notice',
          'cuIcon-upstagefill',
          'cuIcon-upstage',
          'cuIcon-babyfill',
          'cuIcon-baby',
          'cuIcon-brandfill',
          'cuIcon-brand',
          'cuIcon-choicenessfill',
          'cuIcon-choiceness',
          'cuIcon-clothesfill',
          'cuIcon-clothes',
          'cuIcon-creativefill',
          'cuIcon-creative',
          'cuIcon-female',
          'cuIcon-keyboard',
          'cuIcon-male',
          'cuIcon-newfill',
          'cuIcon-new',
          'cuIcon-pullleft',
          'cuIcon-pullright',
          'cuIcon-rankfill',
          'cuIcon-rank',
          'cuIcon-bad',
          'cuIcon-cameraadd',
          'cuIcon-focus',
          'cuIcon-friendfill',
          'cuIcon-cameraaddfill',
          'cuIcon-apps',
          'cuIcon-paintfill',
          'cuIcon-paint',
          'cuIcon-picfill',
          'cuIcon-refresharrow',
          'cuIcon-colorlens',
          'cuIcon-markfill',
          'cuIcon-mark',
          'cuIcon-presentfill',
          'cuIcon-repeal',
          'cuIcon-album',
          'cuIcon-peoplefill',
          'cuIcon-people',
          'cuIcon-servicefill',
          'cuIcon-repair',
          'cuIcon-file',
          'cuIcon-repairfill',
          'cuIcon-taoxiaopu',
          'cuIcon-weixin',
          'cuIcon-attentionfill',
          'cuIcon-attention',
          'cuIcon-commandfill',
          'cuIcon-command',
          'cuIcon-communityfill',
          'cuIcon-community',
          'cuIcon-read',
          'cuIcon-calendar',
          'cuIcon-cut',
          'cuIcon-magic',
          'cuIcon-backwardfill',
          'cuIcon-playfill',
          'cuIcon-stop',
          'cuIcon-tagfill',
          'cuIcon-tag',
          'cuIcon-group',
          'cuIcon-all',
          'cuIcon-backdelete',
          'cuIcon-hotfill',
          'cuIcon-hot',
          'cuIcon-post',
          'cuIcon-radiobox',
          'cuIcon-rounddown',
          'cuIcon-upload',
          'cuIcon-writefill',
          'cuIcon-write',
          'cuIcon-radioboxfill',
          'cuIcon-punch',
          'cuIcon-shake',
          'cuIcon-move',
          'cuIcon-safe',
          'cuIcon-activityfill',
          'cuIcon-crownfill',
          'cuIcon-crown',
          'cuIcon-goodsfill',
          'cuIcon-messagefill',
          'cuIcon-profilefill',
          'cuIcon-sound',
          'cuIcon-sponsorfill',
          'cuIcon-sponsor',
          'cuIcon-upblock',
          'cuIcon-weblock',
          'cuIcon-weunblock',
          'cuIcon-my',
          'cuIcon-myfill',
          'cuIcon-emojifill',
          'cuIcon-emojiflashfill',
          'cuIcon-flashbuyfill',
          'cuIcon-text',
          'cuIcon-goodsfavor',
          'cuIcon-musicfill',
          'cuIcon-musicforbidfill',
          'cuIcon-card',
          'cuIcon-triangledownfill',
          'cuIcon-triangleupfill',
          'cuIcon-roundleftfill-copy',
          'cuIcon-font',
          'cuIcon-title',
          'cuIcon-recordfill',
          'cuIcon-record',
          'cuIcon-cardboardfill',
          'cuIcon-cardboard',
          'cuIcon-formfill',
          'cuIcon-coin',
          'cuIcon-cardboardforbid',
          'cuIcon-circlefill',
          'cuIcon-circle',
          'cuIcon-attentionforbid',
          'cuIcon-attentionforbidfill',
          'cuIcon-attentionfavorfill',
          'cuIcon-attentionfavor',
          'cuIcon-titles',
          'cuIcon-icloading',
          'cuIcon-full',
          'cuIcon-mail',
          'cuIcon-peoplelist',
          'cuIcon-goodsnewfill',
          'cuIcon-goodsnew',
          'cuIcon-medalfill',
          'cuIcon-medal',
          'cuIcon-newsfill',
          'cuIcon-newshotfill',
          'cuIcon-newshot',
          'cuIcon-news',
          'cuIcon-videofill',
          'cuIcon-video',
          'cuIcon-exit',
          'cuIcon-skinfill',
          'cuIcon-skin',
          'cuIcon-moneybagfill',
          'cuIcon-usefullfill',
          'cuIcon-usefull',
          'cuIcon-moneybag',
          'cuIcon-redpacket_fill',
          'cuIcon-subscription',
          'cuIcon-loading1',
          'cuIcon-github',
          'cuIcon-global',
          'cuIcon-settingsfill',
          'cuIcon-back_android',
          'cuIcon-expressman',
          'cuIcon-evaluate_fill',
          'cuIcon-group_fill',
          'cuIcon-play_forward_fill',
          'cuIcon-deliver_fill',
          'cuIcon-notice_forbid_fill',
          'cuIcon-fork',
          'cuIcon-pick',
          'cuIcon-wenzi',
          'cuIcon-ellipse',
          'cuIcon-qr_code',
          'cuIcon-dianhua',
          'cuIcon-icon',
          'cuIcon-loading2',
          'cuIcon-btn',
      ],
      rules:{
        formName:[{}],
        groupId: [],
      }
    }
  },
  computed: {
    // applyTotal(){
    //
    // },
    setup() {
      return this.$store.state.design;
    }
  },
  mounted(){
    this.getGroups()
  },
  methods: {
    choiceApplyDialog(){
      this.select = this.setup.settings.commiter;
      this.$refs.choiceApply.showDialog(this.setup.settings.commiter);
    },
    applyList(list) {
      console.log("设置可查看表单人员选中项："+JSON.stringify(list))
      console.log("此时setup:"+ JSON.stringify(this.setup))
      this.$set(this.setup.settings, 'commiter', list);
    },
    choiceEditDialog(){
      this.select = this.setup.settings.admin;
      this.$refs.choiceEdit.showDialog(this.setup.settings.admin);
    },
    //
    editList(list){

      console.log("此时setup:"+ JSON.stringify(this.setup))
      console.log("设置可管理表单人员选中项:"+JSON.stringify(list))
      this.$set(this.setup.settings, 'admin', list);
    },
    getGroups(){
      getFormGroups().then(rsp => {
        this.fromGroup = rsp.data
      });
    },
    addGroup() {
      if (this.newGroup.trim() !== '') {
        updateGroup({name: this.newGroup.trim()}, 'post').then(rsp => {
          this.$message.success(rsp.data)
          this.getGroups()
        }).catch(err => this.$message.error(err.response.data))
      }
    },
    validate(){
      this.$refs.baseSetting.validate()
      let err = []
      if (!this.$isNotEmpty(this.setup.formName)){
        err.push('表单名称未设置！')
      }
      if (!this.$isNotEmpty(this.setup.groupId)){
        err.push('表单分组未设置！')
      }
      if (this.setup.settings.notify.types.length === 0){
        err.push('审批消息通知方式未设置')
      }
      return err
    },
  }
}
</script>

<style lang="less" scoped>
.icon-logo{
  height: 30px;
  line-height: 30px;
  width: 30px;
  max-height: 30px;
  text-align: center;
  font-size: 20px;
  color: #ffffff;
  border-radius: 8px;
}

.icon-select {
  display: flex;
  flex-wrap: wrap;
  i {
    cursor: pointer;
    font-size: large;
    height: 40px;
    line-height: 40px;
    text-align: center;
    width: 40px;
    &:hover {
      color: white;
      border-radius: 10px;
      background-color: #ff4d4f;
    }
  }
}
.base-setup {
  overflow: auto;
  margin: 0 auto;
  width: 800px;
  background: #ffffff;
  margin-top: 60px;
  padding: 15px 20px;
  i:first-child {
    position: relative;
    cursor: pointer;
    font-size: xx-large;
    color: #ffffff;
    border-radius: 10px;
    padding: 10px;
  }
  .change-icon {
    margin-left: 20px;
    span {
      font-size: small;
      color: #7a7a7a;
      margin-right: 15px;
    }
    i {
      cursor: pointer;
      color: #7a7a7a;
      font-size: x-large;
    }
  }

  ///deep/ .el-form-item__label {
  //  padding: 0;
  //  font-weight: bold;
  //}
  //
  ///deep/ .el-form-item {
  //  margin-bottom: 5px;
  //}
}
.set-button {
  background-color: white;
  width: 210px;
  border: #d8dbe2 1px solid;
  border-radius: 8px;
  height: 40px;
  line-height: 40px;
  padding:0px 8px 0 8px;
  color: #c1c1c1;
  text-align: left;
  display: flex;
  align-items: center;
  position: relative
}
.set-button:hover {
  border: #c0c4cc 1px solid;
}
/deep/ .group {
  .el-select {
    width: calc(100% - 130px);
  }

  .el-button {
    margin-left: 10px;
    width: 120px;
  }
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: #f8f8f8;
}

::-webkit-scrollbar-thumb {
  border-radius: 16px;
  background-color: #e8e8e8;
}
.tag-name{
  overflow: hidden;width: 70px;padding-right: 10px;text-overflow: ellipsis;text-align: center;
  margin-right: 10px;
}
</style>
